/* eslint-disable @typescript-eslint/no-unused-vars */
import Chart from "chart.js";
import axios from "axios";
import store from "../../store/index";
import jwt_decode from "jwt-decode";
import customModal from "../customModal/customModal.vue";
export default {
  name: "CentralizedDashboard",
components: {
        customModal,
    },
  data() {
    return {
      ecrfDrillLevel: "study",
      enrollmentChart: null,
      queryAgingChart: null,
      studies: [],
      ecrfcompletstudy: "",
      saeChart: null,
      sdvChart: null,

      sdvLevel: "study",
      sdvStudyMap: [],
      selectedSdvStudyId: null,
      selectedSdvStudyRef: "",

      sdvMetaInitiated: [],
      sdvMetaCoverage: [],
      sdvMetaVerified: [],
      sdvMetaCoverageSite: [],
      saeLevel: "study",
      saeStudyMap: [],
      selectedSaeStudyId: null,
      selectedSaeStudyRef: "",
      saeMetaMedian: [],
      saeMetaCount: [],
      queryAgingLevel: "study",
      queryAgingPayload: [],
      queryAgingStudyMap: [],
      selectedQueryStudyId: null,
      selectedQueryStudyRef: "",
      enrollmentLevel: "study",
      enrollmentStudyMap: [],
      selectedEnrollmentStudyId: null,
      selectedEnrollmentStudyRef: "",
      screenFailLevel: "study",
      screenFailStudyMap: [],
      selectedStudyId: null,
      selectedStudyRef: "",
      ecrfChart: null,
      screenFailChart: null,
      baseapi: process.env.VUE_APP_Service_URL,
      enrollmentLevelpercentage: "0",
      activeStudies: "0",
      activeSites: "0",
      studyLabels: ["Study 101", "Study 204", "Study 311", "Study 455", "Study 502"],
      highriskscore: 0,
      highRiskStudiesList:[],
      openentrollmentmodel:false,
      highriskstudiesmodel:false,
      enrollmentstudies:[],
      kpiWithScorespopuparray:[],
      riskiemspopup: false,
      studylistarray:[],
      studylistpopup: false,
      highrisksitesarray:[],
      highrisksitespopup: false,
      popupstudyid:"",
      viewkpiWithScorespopup: false,
      viewkpiWithScoresarray:[],
      studykpiWithScorespopuparray:[],
      studykpiWithScorespop: false,
    };
  },

  mounted() {
    this.loadstudy();
    this.initializeCharts();
    this.highriskstudiescount();
    this.setupFilters();

    window.addEventListener("studyIdChanged", (event) => {
      this.loadstudy();
      this.initializeCharts();
      this.highriskstudiescount();
      this.setupFilters();
    });
  },

  beforeUnmount() {
    if (this.enrollmentChart) this.enrollmentChart.destroy();
    if (this.saeChart) this.saeChart.destroy();
    if (this.ecrfChart) this.ecrfChart.destroy();
    if (this.screenFailChart) this.screenFailChart.destroy();
    if (this.sdvChart) this.sdvChart.destroy();
  },

  methods: {
    
    initializeCharts() {
      this.initEnrollmentVelocity();
      this.initScreenFailRate();
      this.initECRFCompleteness();
      this.initQueryAging();
      this.initSDVSDRCoverage();
      this.initSAETimeliness();
      this.gettotalstudydata();
    },
    viewkpiWithScoresfun(data){
      this.viewkpiWithScoresarray = data;
      this.viewkpiWithScorespopup = true;
    },
    async highrisksitespopupfun() {
      const idtoken = store.getters.getIdToken;
      let studyId = store.getters.getStudyIs;
      if(this.popupstudyid == ""){
        this.popupstudyid = studyId;
      }

  axios
    .get(`${this.baseapi}/forms/rbqm/getriskscorestudysitesummary?studyId=${this.popupstudyid}`, {
      headers: {
        Authorization: "Bearer " + idtoken,
        "Content-Type": "application/json",
      },
    })
    .then((res) => {
      this.highrisksitesarray = res.data || [];
      this.highrisksitespopup = true;

    })
    .catch((err) => {
      console.log(err);
    });
},
    viewrisks(riskitems){
        this.kpiWithScorespopuparray = riskitems;
        this.riskiemspopup = true;
    },
    viewstudykpiWithScore(riskitems){
        this.studykpiWithScorespopuparray = riskitems;
        this.studykpiWithScorespop = true;
    },
    async openenrollmentpopup() {
  this.openentrollmentmodel = true;

},
async openstuylistpopup() {
  const idtoken = store.getters.getIdToken;

  axios
    .get(`${this.baseapi}/forms/rbqm/getriskscorestudysitesummary`, {
      headers: {
        Authorization: "Bearer " + idtoken,
        "Content-Type": "application/json",
      },
    })
    .then((res) => {
      this.studylistarray = res.data || [];
      this.studylistpopup = true;
    })
    .catch((err) => {
      console.log(err);
    });
},
    async highriskstudiescount() {
  const idtoken = store.getters.getIdToken;
  this.studyId = store.getters.getStudyIs;

  axios
    .get(`${this.baseapi}/forms/rbqm/getriskscorestudysitesummary`, {
      headers: {
        Authorization: "Bearer " + idtoken,
        "Content-Type": "application/json",
      },
    })
    .then((res) => {
      const highrisklist = res.data || [];

      this.highRiskStudiesList = highrisklist.filter((study) => {
        const totalScore = (study.kpiWithScores || []).reduce((sum, kpi) => {
          return sum + (parseFloat(kpi.score) || 0);
        }, 0);

        return totalScore > 27;
      });

      this.highriskscore = this.highRiskStudiesList.length;

      console.log("High risk count:", this.highriskscore);
      console.log("High risk studies list:", this.highRiskStudiesList);
    })
    .catch((err) => {
      console.log(err);
    });
},
    async loadstudy() {
      const idtoken = store.getters.getIdToken;
      const usermail = jwt_decode(idtoken).email;
      axios
        .get(`${this.baseapi}/management/study/getallstudy?user=${usermail}`, {
          headers: {
            Authorization: "Bearer " + idtoken,
            "Content-Type": "application/json",
          },
        })
        .then((res) => {
          this.studies = res.data;

        })
        .catch(async (err) => {
          console.log(err);
        });
    },
    resetScreenFailChart() {
      this.loadScreenFailRatePortfolio();
    },
    setupFilters() {
      const resetBtn = document.getElementById("resetFilters");
      if (!resetBtn) return;

      resetBtn.addEventListener("click", (e) => {
        e.preventDefault();

        const studyFilter = document.getElementById("studyFilter");
        const regionFilter = document.getElementById("regionFilter");
        const siteStatusFilter = document.getElementById("siteStatusFilter");
        const startDate = document.getElementById("startDate");
        const endDate = document.getElementById("endDate");

        if (studyFilter) studyFilter.selectedIndex = 0;
        if (regionFilter) regionFilter.selectedIndex = 0;
        if (siteStatusFilter) siteStatusFilter.selectedIndex = 0;
        if (startDate) startDate.value = "2024-01-01";
        if (endDate) endDate.value = "2024-06-30";
      });
    },

    /* 1. Enrollment Velocity */
    initEnrollmentVelocity() {
      const canvas = document.getElementById("enrollmentRateChart");
      if (!canvas) return;

      if (this.enrollmentChart) this.enrollmentChart.destroy();

      const ctx = canvas.getContext("2d");

      this.enrollmentChart = new Chart(ctx, {
        type: "bar",
        data: {
          labels: [],
          datasets: [
            {
              label: "Enrollment %",
              data: [],
              backgroundColor: "#1565c0",
            },
          ],
        },
        options: {
          responsive: true,
          maintainAspectRatio: false,

          // helps clicking near labels too
          hover: { mode: "nearest", intersect: false },
          interaction: { mode: "nearest", intersect: false }, // v3+

          plugins: {
            legend: { display: false },

            // v3/v4 tooltips
            tooltip: {
              callbacks: {
                label: (ctx) => {
                  var i = ctx.dataIndex;

                  var ds = (this.screenFailChart && this.screenFailChart.data && this.screenFailChart.data.datasets)
                    ? this.screenFailChart.data.datasets
                    : [];

                  var screened = (ds[0] && ds[0].data && ds[0].data[i] != null) ? ds[0].data[i] : 0;
                  var failures = (ds[1] && ds[1].data && ds[1].data[i] != null) ? ds[1].data[i] : 0;
                  var pct = (ds[2] && ds[2].data && ds[2].data[i] != null) ? ds[2].data[i] : 0;

                  // show tooltip text only when hovering the visible dataset (Failure %)
                  if (ctx.datasetIndex !== 2) return "";

                  return [
                    "Failure %: " + Number(pct).toFixed(2) + "%",
                    "Screened: " + screened,
                    "Screen Failures: " + failures,
                  ];
                },
              },
            },

          },

          tooltips: {
            enabled: true,
            mode: "nearest",
            intersect: false,
            callbacks: {
              label: (tooltipItem) => {
                var i = tooltipItem.index;

                var actualArr = this.enrollmentMetaActual || [];
                var plannedArr = this.enrollmentMetaPlanned || [];
                var percentArr = this.enrollmentMetaPercent || [];

                var a = (actualArr[i] !== undefined && actualArr[i] !== null) ? actualArr[i] : 0;
                var p = (plannedArr[i] !== undefined && plannedArr[i] !== null) ? plannedArr[i] : 0;
                var pct = (percentArr[i] !== undefined && percentArr[i] !== null) ? percentArr[i] : 0;

                return [
                  "Actual: " + a,
                  "Planned: " + p,
                  "Percentage: " + Number(pct).toFixed(2) + "%"
                ];
              },
            },
          },
          onClick: (evt) => {
            const chart = this.enrollmentChart;
            if (!chart) return;

            // v3/v4
            const points = chart.getElementsAtEventForMode(
              evt,
              "nearest",
              { intersect: true },
              false
            );

            // v2 fallback
            const v2points =
              typeof chart.getElementAtEvent === "function"
                ? chart.getElementAtEvent(evt)
                : [];

            const hit = (points && points[0]) || (v2points && v2points[0]);
            if (!hit) return;

            const index =
              typeof hit.index === "number" ? hit.index : hit._index;

            if (this.enrollmentLevel === "study") {
              const picked = this.enrollmentStudyMap[index];
              if (picked && picked.studyId) {
                this.selectedEnrollmentStudyId = picked.studyId;
                this.selectedEnrollmentStudyRef = picked.studyRef || "";
                this.loadEnrollmentByStudy(picked.studyId);
              }
            }
          },
          scales: {
            yAxes: [{ ticks: { beginAtZero: true }, scaleLabel: { display: true, labelString: "Enrollment Percentage (%)" } }], // v2
            xAxes: [{ ticks: { autoSkip: false } }], // v2
          },
        }


      });

      // initial load
      this.loadEnrollmentPortfolio();
    },
    async loadEnrollmentPortfolio() {
      try {
        const idtoken = store.getters.getIdToken;

        const res = await axios.get(
          `${this.baseapi}/forms/rbqm/getenrolmentpercentage`,
          {
            headers: {
              Authorization: "Bearer " + idtoken,
              "Content-Type": "application/json",
            },
          }
        );
        this.enrollmentLevelpercentage = res.data.overall.percentage;
        const rows = Array.isArray(res.data.studies) ? res.data.studies : [];
        this.enrollmentstudies = rows;

        this.enrollmentLevel = "study";
        this.selectedEnrollmentStudyId = null;
        this.selectedEnrollmentStudyRef = "";

        // map index -> studyId
        this.enrollmentStudyMap = rows.map((r) => ({
          studyId: r.studyId,
          studyRef: r.studyRef,
        }));

        const labels = rows.map((r) => r.studyRef || "-");
        const percent = rows.map((r) => Number(r.percentage) || 0);

        // store tooltip meta arrays aligned with labels
        this.enrollmentMetaActual = rows.map((r) => Number(r.actual) || 0);
        this.enrollmentMetaPlanned = rows.map((r) => Number(r.planned) || 0);
        this.enrollmentMetaPercent = rows.map((r) => Number(r.percentage) || 0);
        this.enrollmentMetaPercent = percent;

        this.applyEnrollmentChartData(labels, percent);
      } catch (err) {
        console.error("Enrollment portfolio API error", err);
      }
    },
    async loadEnrollmentByStudy(studyId) {
      try {
        const idtoken = store.getters.getIdToken;

        const res = await axios.get(
          `${this.baseapi}/forms/rbqm/getenrolmentpercentage?studyId=${encodeURIComponent(studyId)}`,
          {
            headers: {
              Authorization: "Bearer " + idtoken,
              "Content-Type": "application/json",
            },
          }
        );
        this.enrollmentLevelpercentage = res.data.percentage;
        const obj = res.data || {};
        const sites = Array.isArray(obj.sites) ? obj.sites : [];

        this.enrollmentLevel = "site";

        const labels = sites.map((s) => s.siteCode || "-");
        const percent = sites.map((s) => Number(s.percentage) || 0);

        // tooltip meta arrays
        this.enrollmentMetaActual = sites.map((s) => Number(s.actual) || 0);
        this.enrollmentMetaPlanned = sites.map((s) => Number(s.planned) || 0);
        this.enrollmentMetaPercent = sites.map((s) => Number(s.percentage) || 0);
        this.enrollmentMetaPercent = percent;

        this.applyEnrollmentChartData(labels, percent);
      } catch (err) {
        console.error("Enrollment drilldown API error", err);
      }
    },
    async gettotalstudydata() {
      try {
        const idtoken = store.getters.getIdToken;

        const res = await axios.get(
          `${this.baseapi}/forms/rbqm/gettotalstudydata`,
          {
            headers: {
              Authorization: "Bearer " + idtoken,
              "Content-Type": "application/json",
            },
          }
        );
        this.activeStudies = res.data.activeStudies;
        this.activeSites = res.data.activeSites;
      } catch (err) {
        console.error("Enrollment drilldown API error", err);
      }
    },
    applyEnrollmentChartData(labels, percent) {
      if (!this.enrollmentChart) return;

      this.enrollmentChart.data.labels = labels;
      this.enrollmentChart.data.datasets[0].data = percent;

      // ✅ Update X-axis label based on drilldown level
      const xLabel = this.enrollmentLevel === "study" ? "Studies" : "Sites";

      // Chart.js v2
      if (this.enrollmentChart.options?.scales?.xAxes?.[0]?.scaleLabel) {
        this.enrollmentChart.options.scales.xAxes[0].scaleLabel.display = true;
        this.enrollmentChart.options.scales.xAxes[0].scaleLabel.labelString = xLabel;
      }

      // Chart.js v3/v4
      if (this.enrollmentChart.options?.scales?.x?.title) {
        this.enrollmentChart.options.scales.x.title.display = true;
        this.enrollmentChart.options.scales.x.title.text = xLabel;
      }

      // horizontal scroll width
      var perCategoryPx = 90;
      var minWidth = 600;
      var targetWidth = Math.max(minWidth, labels.length * perCategoryPx);

      var canvas = document.getElementById("enrollmentRateChart");
      if (canvas) {
        var inner = canvas.closest(".chart-inner");
        if (inner) inner.style.width = targetWidth + "px";
      }

      this.enrollmentChart.update();
    },

    resetEnrollmentChart() {
      this.loadEnrollmentPortfolio();
    },


    /* 2. Screen Fail Rate (stacked) */
    initScreenFailRate() {
      const canvas = document.getElementById("screenFailChart");
      if (!canvas) return;

      if (this.screenFailChart) this.screenFailChart.destroy();

      const ctx = canvas.getContext("2d");

      this.screenFailChart = new Chart(ctx, {
        type: "bar",
        data: {
          labels: [],
          datasets: [
            // keep these datasets for tooltip/meta, but hide them visually
            { label: "Screened", data: [], backgroundColor: "#2f8ccc", hidden: true },
            { label: "Screen Failures", data: [], backgroundColor: "#ee5c7b", hidden: true },
            { label: "Failure %", data: [], backgroundColor: "#f1c251", hidden: false },
          ],
        },
        options: {
          responsive: true,
          maintainAspectRatio: false,

          // easier hover/click
          hover: { mode: "index", intersect: false },
          tooltips: {
            mode: "index",
            intersect: false,
            callbacks: {
              label: function (tooltipItem, data) {
                var i = tooltipItem.index;

                // show tooltip only when hovering "Failure %" dataset
                if (tooltipItem.datasetIndex !== 2) return null;

                var datasets = data && data.datasets ? data.datasets : [];

                var screened =
                  datasets[0] && datasets[0].data && datasets[0].data[i] != null
                    ? datasets[0].data[i]
                    : 0;

                var failures =
                  datasets[1] && datasets[1].data && datasets[1].data[i] != null
                    ? datasets[1].data[i]
                    : 0;

                var pct =
                  datasets[2] && datasets[2].data && datasets[2].data[i] != null
                    ? datasets[2].data[i]
                    : 0;

                return [
                  "Failure %: " + Number(pct).toFixed(2) + "%",
                  "Screened: " + screened,
                  "Screen Failures: " + failures,
                ];
              },

              // keep as-is (your current behavior)
              labelTextColor: function () {
                return "#fff9f9";
              },
            },
          },

          legend: {
            position: "top",
            labels: {
              // keep as-is (your current behavior)
              filter: function (legendItem) {
                return legendItem.datasetIndex === 2; // show only Failure %
              },
            },
          },

          // ✅ AXIS LABELS ADDED HERE
          scales: {
            xAxes: [
              {
                scaleLabel: {
                  display: true,
                  labelString: "Studies", // initial
                },
                ticks: { autoSkip: false },
              },
            ],
            yAxes: [
              {
                scaleLabel: {
                  display: true,
                  labelString: "Failure Percentage",
                },
                ticks: {
                  beginAtZero: true,
                  callback: function (v) {
                    return v + "%";
                  },
                },
              },
            ],
          },

          onClick: (evt) => {
            const chart = this.screenFailChart;
            if (!chart) return;

            const v2points =
              typeof chart.getElementAtEvent === "function"
                ? chart.getElementAtEvent(evt)
                : [];

            const hit = v2points && v2points[0];
            if (!hit) return;

            const index = typeof hit._index === "number" ? hit._index : null;
            if (index == null) return;

            // drilldown only from study view
            if (this.screenFailLevel === "study") {
              const picked = this.screenFailStudyMap && this.screenFailStudyMap[index];
              if (picked && picked.studyId) {
                this.selectedStudyId = picked.studyId;
                this.selectedStudyRef = picked.studyRef || "";

                // ✅ change X-axis label to Sites on drilldown
                this.screenFailLevel = "site";
                this.screenFailChart.options.scales.xAxes[0].scaleLabel.labelString = "Sites";
                this.screenFailChart.update();

                this.loadScreenFailRateByStudy(picked.studyId);
              }
            }
          },
        },
      });

      // initial load: portfolio
      this.screenFailLevel = "study";
      if (this.screenFailChart && this.screenFailChart.options && this.screenFailChart.options.scales) {
        this.screenFailChart.options.scales.xAxes[0].scaleLabel.labelString = "Studies";
        this.screenFailChart.update();
      }

      this.loadScreenFailRatePortfolio();
    },




    async loadScreenFailRatePortfolio() {
      const idtoken = store.getters.getIdToken;

      const res = await axios.get(
        `${this.baseapi}/forms/rbqm/getscreenfailurerate`,
        {
          headers: {
            Authorization: "Bearer " + idtoken,
            "Content-Type": "application/json",
          },
        }
      );

      const rows = Array.isArray(res.data) ? res.data : [];

      this.screenFailLevel = "study";

      this.screenFailStudyMap = rows.map((r) => ({
        studyId: r.studyId,
        studyRef: r.studyRef,
      }));

      const labels = rows.map((r) => r.studyRef || "-");
      const screened = rows.map((r) => Number(r.screenedCount) || 0);
      const failures = rows.map((r) => Number(r.screenFailureCount) || 0);
      const pct = rows.map((r) => Number(r.percentage) || 0);

      this.applyScreenFailChartData(labels, screened, failures, pct);
    },

    async loadScreenFailRateByStudy(studyId) {
      try {
        this.screenFailLevel = "site";

        const idtoken = store.getters.getIdToken;

        const res = await axios.get(
          `${this.baseapi}/forms/rbqm/getscreenfailurerate?studyId=${encodeURIComponent(studyId)}`,
          {
            headers: {
              Authorization: "Bearer " + idtoken,
              "Content-Type": "application/json",
            },
          }
        );

        const rows = Array.isArray(res.data) ? res.data : [];

        // Now labels are site codes
        const labels = rows.map((r) => r.siteCode || "-");
        const screened = rows.map((r) => Number(r.screenedCount) || 0);
        const failures = rows.map((r) => Number(r.screenFailureCount) || 0);
        const pct = rows.map((r) => Number(r.percentage) || 0);

        this.applyScreenFailChartData(labels, screened, failures, pct);
      } catch (err) {
        console.error("Screen fail drilldown API error", err);
      }
    },

    applyScreenFailChartData(labels, screened, failures, pct) {
      if (!this.screenFailChart) return;

      this.screenFailChart.data.labels = labels;
      this.screenFailChart.data.datasets[0].data = screened;
      this.screenFailChart.data.datasets[1].data = failures;
      this.screenFailChart.data.datasets[2].data = pct;
      this.screenFailChart.data.datasets[0].hidden = true;
      this.screenFailChart.data.datasets[1].hidden = true;
      this.screenFailChart.data.datasets[2].hidden = false;

      // scrollbar sizing
      const perCategoryPx = 80;
      const minWidth = 600;
      const targetWidth = Math.max(minWidth, labels.length * perCategoryPx);

      const canvas = document.getElementById("screenFailChart");
      const inner = canvas?.closest(".chart-inner");
      if (inner) inner.style.width = `${targetWidth}px`;

      this.screenFailChart.update();
    },
    backToScreenFailPortfolio() {
      this.loadScreenFailRatePortfolio();
    },

    /* 3. eCRF Completeness (doughnut) */
    initECRFCompleteness() {
      var canvas = document.getElementById("ecrfCompletenessChart");
      if (!canvas) return;

      canvas.style.pointerEvents = "auto";

      // destroy old chart
      if (this.ecrfChart) {
        this.ecrfChart.destroy();
        this.ecrfChart = null;
      }

      // remove old click handler
      if (this._ecrfClickHandler) {
        canvas.removeEventListener("click", this._ecrfClickHandler);
        this._ecrfClickHandler = null;
      }

      // create chart
      this.ecrfChart = new Chart(canvas, {
        type: "bar",
        data: {
          labels: [],
          datasets: [
            { label: "On Time", data: [], backgroundColor: "#47b5b5", stack: "crf" },
            { label: "Late", data: [], backgroundColor: "#e25875", stack: "crf" },
          ],
        },
        options: {
          responsive: true,
          maintainAspectRatio: false,

          // make sure chart listens to clicks/touch
          events: ["mousemove", "mouseout", "click", "touchstart", "touchmove"],

            scales: {
            yAxes: [{
              ticks: { beginAtZero: true },
              stacked: true,
              scaleLabel: { display: true, labelString: "Count" },
            }],
            xAxes: [{
              ticks: { autoSkip: false },
              stacked: true,
              scaleLabel: { display: true, labelString: "Studies" },
            }],
            },
            plugins: {
            legend: { position: "bottom" },
            tooltip: {
              callbacks: {
                title: (items) => {
                  var it = items && items[0];
                  if (!it) return "";

                  var labels =
                    this.ecrfChart && this.ecrfChart.data && this.ecrfChart.data.labels
                      ? this.ecrfChart.data.labels
                      : [];

                  return labels[it.dataIndex] != null ? String(labels[it.dataIndex]) : "";
                },
                footer: (items) => {
                  var it = items && items[0];
                  if (!it) return "";

                  var idx = it.dataIndex;

                  var ds0 =
                    this.ecrfChart &&
                      this.ecrfChart.data &&
                      this.ecrfChart.data.datasets &&
                      this.ecrfChart.data.datasets[0] &&
                      this.ecrfChart.data.datasets[0].data
                      ? this.ecrfChart.data.datasets[0].data
                      : [];

                  var ds1 =
                    this.ecrfChart &&
                      this.ecrfChart.data &&
                      this.ecrfChart.data.datasets &&
                      this.ecrfChart.data.datasets[1] &&
                      this.ecrfChart.data.datasets[1].data
                      ? this.ecrfChart.data.datasets[1].data
                      : [];

                  var on = Number(ds0[idx] != null ? ds0[idx] : 0);
                  var late = Number(ds1[idx] != null ? ds1[idx] : 0);
                  var due = on + late;
                  var ratio = due > 0 ? ((on / due) * 100).toFixed(2) : "0.00";

                  return "Due: " + due + " | On Time: " + on + " | Late: " + late + " | Ratio: " + ratio + "%";
                },
              },
            },
          },
        },
      });

      // DOM click handler (reliable in modals)
      this._ecrfClickHandler = (evt) => {
        console.log("[eCRF] canvas click. drillLevel =", this.ecrfDrillLevel);

        var chart = this.ecrfChart;
        if (!chart) return;

        // Get nearest element (works even if elements arg is flaky)
        var items = chart.getElementsAtEventForMode(evt, "nearest", { intersect: false }, true);
        console.log("[eCRF] hit items:", items);

        var idx = null;

        if (items && items.length) {
          var it = items[0];

          // Different chartjs builds expose index differently (esp with Proxy)
          if (typeof it.index === "number") idx = it.index;
          else if (typeof it.dataIndex === "number") idx = it.dataIndex;
          else if (typeof it._index === "number") idx = it._index;
          else if (typeof it._datasetIndex === "number" && typeof it._index === "number") idx = it._index;
        }

        // Fallback: compute index from x-scale pixel position
        if (idx === null) {
          var xScale = chart.scales && (chart.scales.x || chart.scales["x-axis-0"]);
          if (xScale && typeof xScale.getValueForPixel === "function") {
            var v = xScale.getValueForPixel(evt.offsetX);
            if (typeof v === "number") idx = v;
            else {
              var labels2 = chart.data && chart.data.labels ? chart.data.labels : [];
              var pos = labels2.indexOf(v);
              idx = pos >= 0 ? pos : null;
            }
          }
        }

        console.log("[eCRF] resolved index:", idx);
        if (idx === null) return;

        // ✅ Drilldown only from study level
        if (this.ecrfDrillLevel !== "study") {
          console.log("[eCRF] click ignored: already in site view. Use Back.");
          return;
        }

        var row = this.ecrfStudyRows && this.ecrfStudyRows[idx] ? this.ecrfStudyRows[idx] : null;
        console.log("[eCRF] study row:", row);

        if (!row || !row.studyId) {
          console.log("[eCRF] no studyId found at index", idx);
          return;
        }

        console.log("[eCRF] drilling down, calling API with studyId:", row.studyId);
        this.getEcrfSitesAndRender(row.studyId, row.studyRef);
      };

      canvas.addEventListener("click", this._ecrfClickHandler);

      // initial load
      this.getEcrfStudiesAndRender();
    },



    async getEcrfSitesAndRender(studyId, studyRef) {
      try {
        const idtoken = store.getters.getIdToken;

        const res = await axios.get(
          `${this.baseapi}/forms/rbqm/getcrfcompletecount?studyId=${encodeURIComponent(studyId)}`,
          {
            headers: {
              Authorization: "Bearer " + idtoken,
              "Content-Type": "application/json",
            },
          }
        );

        const obj = res.data || {};
        this.ecrfSiteRows = Array.isArray(obj.sites) ? obj.sites : [];

        // ✅ IMPORTANT: switch to site mode
        this.ecrfDrillLevel = "site";
        this.ecrfCurrentTitle = studyRef || obj.studyRef || "Study";

        console.log("[eCRF] loaded sites:", this.ecrfSiteRows.length);

        this.renderEcrfStacked(this.ecrfSiteRows, "siteCode");
      } catch (err) {
        console.error("eCRF completeness (sites) API error", err);
      }
    },



    // ---------- BACK ----------
    ecrfBackToStudies() {
      console.log("[eCRF] back to studies");
      this.getEcrfStudiesAndRender();
    },
    async getEcrfStudiesAndRender() {
      try {
        const idtoken = store.getters.getIdToken;

        const res = await axios.get(
          `${this.baseapi}/forms/rbqm/getcrfcompletecount`,
          {
            headers: {
              Authorization: "Bearer " + idtoken,
              "Content-Type": "application/json",
            },
          }
        );

        this.ecrfStudyRows = Array.isArray(res.data) ? res.data : [];

        // ✅ IMPORTANT: force study mode
        this.ecrfDrillLevel = "study";
        this.ecrfCurrentTitle = "Portfolio";

        console.log("[eCRF] loaded studies:", this.ecrfStudyRows.length);

        this.renderEcrfStacked(this.ecrfStudyRows, "studyRef");
      } catch (err) {
        console.error("eCRF completeness (portfolio) API error", err);
      }
    },


    renderEcrfStacked(rows, labelKey) {
      if (!this.ecrfChart) return;

      var safeRows = rows || [];

      var labels = safeRows.map(function (r) {
        return r && r[labelKey] ? r[labelKey] : "-";
      });

      var ontime = safeRows.map(function (r) {
        return Number(r && r.ontimeCount != null ? r.ontimeCount : 0);
      });

      var late = safeRows.map(function (r) {
        return Number(r && r.dueCount != null ? r.dueCount : 0);
      });

      this.ecrfChart.data.labels = labels;
      this.ecrfChart.data.datasets[0].data = ontime;
      this.ecrfChart.data.datasets[1].data = late;

      this.ecrfChart.update();
    },

    /* 4. Query Aging (line) */
    initQueryAging() {
      var canvas = document.getElementById("queryAgingChart");
      if (!canvas) return;

      if (this.queryAgingChart) this.queryAgingChart.destroy();

      var ctx = canvas.getContext("2d");

      this.queryAgingChart = new Chart(ctx, {
        type: "line",
        data: {
          labels: [],
          datasets: [
            { label: "0-3d", data: [], borderColor: "#3398dd", backgroundColor: "#3398dd", tension: 0.3, fill: false },
            { label: "4-7d", data: [], borderColor: "#43acac", backgroundColor: "#43acac", tension: 0.3, fill: false },
            { label: "8-14d", data: [], borderColor: "#e1b54c", backgroundColor: "#e1b54c", tension: 0.3, fill: false },
            { label: "15+d", data: [], borderColor: "#e25875", backgroundColor: "#e25875", tension: 0.3, fill: false },
          ],
        },

        options: {
          responsive: true,
          maintainAspectRatio: false,

          hover: { mode: "nearest", intersect: false },
          tooltips: {
            mode: "nearest",
            intersect: false,
            callbacks: {
              // show totals + 15+%
              afterLabel: (tooltipItem) => {
                var i = tooltipItem.index;

                var totals = this.queryAgingMetaTotal || [];
                var perc15 = this.queryAgingMetaPerc15 || [];

                var t = (totals[i] !== undefined && totals[i] !== null) ? totals[i] : 0;
                var p = (perc15[i] !== undefined && perc15[i] !== null) ? perc15[i] : 0;

                return ["Total Open: " + t, "15+ %: " + Number(p).toFixed(2) + "%"];
              },
            },
          },

          onClick: (evt) => {
            this.handleQueryAgingClick(evt);
          },

          scales: {
            yAxes: [{
              ticks: { beginAtZero: true },
              scaleLabel: { display: true, labelString: "Query Count" },
            }],
            xAxes: [{
              ticks: { autoSkip: false },
              scaleLabel: { display: true, labelString: (this.queryAgingLevel === "study" ? "Studies" : "Sites") },
            }],
          },

          legend: { position: "bottom" },
        },
      });

      // initial data load
      this.loadQueryAging();
    },

    async loadQueryAging() {
      try {
        var idtoken = store.getters.getIdToken;

        var res = await axios.get(
          this.baseapi + "/forms/rbqm/getqueryagingcount",
          {
            headers: {
              Authorization: "Bearer " + idtoken,
              "Content-Type": "application/json",
            },
          }
        );

        var rows = Array.isArray(res.data) ? res.data : [];
        this.queryAgingPayload = rows;

        // start in study mode
        this.queryAgingLevel = "study";
        this.selectedQueryStudyId = null;
        this.selectedQueryStudyRef = "";

        this.renderQueryAgingStudies(rows);
      } catch (err) {
        console.error("getqueryagingcount API error", err);
      }
    },
    renderQueryAgingStudies(rows) {
      // map index -> study
      this.queryAgingStudyMap = rows.map((r) => ({
        studyId: r.studyId,
        studyRef: r.studyRef,
      }));

      var labels = rows.map((r) => r.studyRef || "-");

      var d03 = [];
      var d47 = [];
      var d814 = [];
      var d15 = [];
      var totals = [];
      var perc15 = [];

      for (var i = 0; i < rows.length; i++) {
        var a = rows[i] && rows[i].aging ? rows[i].aging : {};
        d03.push(Number(a.d0_3) || 0);
        d47.push(Number(a.d4_7) || 0);
        d814.push(Number(a.d8_14) || 0);
        d15.push(Number(a.d15_plus) || 0);

        totals.push(Number(rows[i].totalOpenQueries) || 0);
        perc15.push(Number(rows[i].percent15Plus) || 0);
      }

      this.queryAgingMetaTotal = totals;
      this.queryAgingMetaPerc15 = perc15;

      this.applyQueryAgingChartData(labels, d03, d47, d814, d15);
    },
    renderQueryAgingSites(studyId) {
      var rows = this.queryAgingPayload || [];
      var picked = null;

      for (var i = 0; i < rows.length; i++) {
        if (rows[i] && rows[i].studyId === studyId) {
          picked = rows[i];
          break;
        }
      }
      if (!picked) return;

      this.queryAgingLevel = "site";
      this.selectedQueryStudyId = studyId;
      this.selectedQueryStudyRef = picked.studyRef || "";

      var sites = Array.isArray(picked.sites) ? picked.sites : [];
      var labels = sites.map((s) => s.siteCode || "-");

      var d03 = [];
      var d47 = [];
      var d814 = [];
      var d15 = [];
      var totals = [];
      var perc15 = [];

      for (var j = 0; j < sites.length; j++) {
        var a = sites[j] && sites[j].aging ? sites[j].aging : {};
        d03.push(Number(a.d0_3) || 0);
        d47.push(Number(a.d4_7) || 0);
        d814.push(Number(a.d8_14) || 0);
        d15.push(Number(a.d15_plus) || 0);

        totals.push(Number(sites[j].totalOpenQueries) || 0);
        perc15.push(Number(sites[j].percent15Plus) || 0);
      }

      this.queryAgingMetaTotal = totals;
      this.queryAgingMetaPerc15 = perc15;

      this.applyQueryAgingChartData(labels, d03, d47, d814, d15);
    },
    applyQueryAgingChartData(labels, d03, d47, d814, d15) {
      if (!this.queryAgingChart) return;

      this.queryAgingChart.data.labels = labels;
      this.queryAgingChart.data.datasets[0].data = d03;
      this.queryAgingChart.data.datasets[1].data = d47;
      this.queryAgingChart.data.datasets[2].data = d814;
      this.queryAgingChart.data.datasets[3].data = d15;

      // horizontal scroll sizing (if you wrap this chart too)
      var perCategoryPx = 80;
      var minWidth = 600;
      var targetWidth = Math.max(minWidth, labels.length * perCategoryPx);

      var canvas = document.getElementById("queryAgingChart");
      if (canvas) {
        var inner = canvas.closest(".chart-inner");
        if (inner) inner.style.width = targetWidth + "px";
      }

      this.queryAgingChart.update();
    },
    getIndexFromClick_query(evt, chart) {
      if (!chart) return null;

      // 1) try hit element
      if (typeof chart.getElementAtEvent === "function") {
        var el = chart.getElementAtEvent(evt);
        if (el && el.length) return el[0]._index;
      }

      // 2) fallback: x-axis tick nearest
      var rect = chart.canvas.getBoundingClientRect();
      var x = evt.clientX - rect.left;

      var xScale = chart.scales && (chart.scales["x-axis-0"] || chart.scales["x"]);
      if (!xScale) return null;

      var ticks = xScale.ticks || [];
      if (!ticks.length) return null;

      var minDist = Infinity;
      var nearest = null;

      for (var i = 0; i < ticks.length; i++) {
        var px = xScale.getPixelForTick(i);
        var dist = Math.abs(px - x);
        if (dist < minDist) {
          minDist = dist;
          nearest = i;
        }
      }

      if (minDist > 40) return null;
      return nearest;
    },

    handleQueryAgingClick(evt) {
      var chart = this.queryAgingChart;
      if (!chart) return;

      // only drilldown when in study mode
      if (this.queryAgingLevel !== "study") return;

      var index = this.getIndexFromClick_query(evt, chart);
      if (index === null || index === undefined) return;

      var picked = this.queryAgingStudyMap && this.queryAgingStudyMap[index];
      if (picked && picked.studyId) {
        this.renderQueryAgingSites(picked.studyId);
      }
    },
    resetQueryAgingChart() {
      this.queryAgingLevel = "study";
      this.selectedQueryStudyId = null;
      this.selectedQueryStudyRef = "";
      this.renderQueryAgingStudies(this.queryAgingPayload || []);
    },
    /* 5. SDV / SDR Coverage */
    initSDVSDRCoverage() {
      var canvas = document.getElementById("sdvCoverageChart");
      if (!canvas) return;

      if (this.sdvChart) this.sdvChart.destroy();

      var ctx = canvas.getContext("2d");

      this.sdvChart = new Chart(ctx, {
        type: "bar",
        data: {
          labels: [],
          datasets: [
            {
              label: "Total Required",
              data: [],
              backgroundColor: "#90a4ae",
            },
            {
              label: "Completed",
              data: [],
              backgroundColor: "#2e7d32",
            },
          ],
        },
        options: {
          responsive: true,
          maintainAspectRatio: false,

          hover: { mode: "nearest", intersect: false },
          tooltips: {
            mode: "index",
            intersect: false,
            callbacks: {
              // show both bars + extra info from meta arrays
              afterBody: (items) => {
                if (!items || !items.length) return "";

                var i = items[0].index;

                // study view extra info
                if (this.sdvLevel === "study") {
                  var init = (this.sdvMetaInitiated && this.sdvMetaInitiated[i] != null) ? this.sdvMetaInitiated[i] : 0;
                  var cov = (this.sdvMetaCoverage && this.sdvMetaCoverage[i] != null) ? this.sdvMetaCoverage[i] : 0;
                  return [
                    "Initiated: " + init,
                    "Coverage %: " + cov,
                  ];
                }

                // site view extra info
                var ver = (this.sdvMetaVerified && this.sdvMetaVerified[i] != null) ? this.sdvMetaVerified[i] : 0;
                var cov2 = (this.sdvMetaCoverageSite && this.sdvMetaCoverageSite[i] != null) ? this.sdvMetaCoverageSite[i] : 0;
                return [
                  "Verified: " + ver,
                  "Coverage %: " + cov2,
                ];
              },
            },
          },

          onClick: (evt) => this.handleSdvClick(evt),

          scales: {
            xAxes: [{
              stacked: false,
              ticks: { autoSkip: false },
              scaleLabel: {
                display: true,
                labelString: (this.sdvLevel === "study" ? "Studies" : "Sites"),
              },
            }],
            yAxes: [{
              stacked: false,
              ticks: { beginAtZero: true },
              scaleLabel: { display: true, labelString: "Count" },
            }],
          },

          legend: { position: "bottom" },

        },
      });

      // initial study load
      this.loadSdvStudies();
    },
    async loadSdvStudies() {
      try {
        var idtoken = store.getters.getIdToken;

        var res = await axios.get(
          this.baseapi + "/forms/rbqm/getsdvcoverage",
          {
            headers: {
              Authorization: "Bearer " + idtoken,
              "Content-Type": "application/json",
            },
          }
        );

        var rows = Array.isArray(res.data) ? res.data : [];

        this.sdvLevel = "study";
        this.selectedSdvStudyId = null;
        this.selectedSdvStudyRef = "";

        // map for drilldown
        this.sdvStudyMap = rows.map((r) => ({
          studyId: r.studyId,
          studyRef: r.studyRef,
        }));

        var labels = rows.map((r) => r.studyRef || "-");
        var totalReq = rows.map((r) => Number(r.totalRequired) || 0);
        var completed = rows.map((r) => Number(r.completedCount) || 0);

        // meta for tooltip
        this.sdvMetaInitiated = rows.map((r) => Number(r.initiatedCount) || 0);
        this.sdvMetaCoverage = rows.map((r) => Number(r.coveragePercent) || 0);

        this.applySdvChartData(labels, totalReq, completed);

      } catch (err) {
        console.error("getsdvcoverage studies API error", err);
      }
    },
    async loadSdvSitesByStudy(studyId, studyRef) {
      try {
        var idtoken = store.getters.getIdToken;

        var res = await axios.get(
          this.baseapi + "/forms/rbqm/getsdvcoverage?studyId=" + encodeURIComponent(studyId),
          {
            headers: {
              Authorization: "Bearer " + idtoken,
              "Content-Type": "application/json",
            },
          }
        );

        var obj = res.data || {};
        var rows = Array.isArray(obj.sites) ? obj.sites : [];

        this.sdvLevel = "site";
        this.selectedSdvStudyId = studyId;
        this.selectedSdvStudyRef = studyRef || "";

        var labels = rows.map((r) => r.siteCode || "-");
        var totalReq = rows.map((r) => Number(r.totalRequired) || 0);
        var pending = rows.map((r) => Number(r.pendingCount) || 0);

        // meta for tooltip
        this.sdvMetaVerified = rows.map((r) => Number(r.verifiedCount) || 0);
        this.sdvMetaCoverageSite = rows.map((r) => Number(r.coveragePercent) || 0);

        // Change dataset labels for site view
        if (this.sdvChart) {
          this.sdvChart.data.datasets[0].label = "Total Required";
          this.sdvChart.data.datasets[1].label = "Pending";
          this.sdvChart.data.datasets[1].backgroundColor = "#f39c12";
        }

        this.applySdvChartData(labels, totalReq, pending);

      } catch (err) {
        console.error("getsdvcoverage sites drilldown API error", err);
      }
    },

    applySdvChartData(labels, seriesA, seriesB) {
      if (!this.sdvChart) return;

      this.sdvChart.data.labels = labels;
      this.sdvChart.data.datasets[0].data = seriesA;
      this.sdvChart.data.datasets[1].data = seriesB;

      // horizontal scroll sizing
      var perCategoryPx = 95;
      var minWidth = 600;
      var targetWidth = Math.max(minWidth, labels.length * perCategoryPx);

      var canvas = document.getElementById("sdvCoverageChart");
      if (canvas) {
        var inner = canvas.closest(".chart-inner");
        if (inner) inner.style.width = targetWidth + "px";
      }

      this.sdvChart.update();
    },
    getIndexFromClick_sdv(evt, chart) {
      if (!chart) return null;

      // 1) bar click
      var els = chart.getElementsAtEventForMode
        ? chart.getElementsAtEventForMode(evt, "nearest", { intersect: true }, true)
        : [];

      if (els && els.length) return els[0]._index;

      // 2) label click (nearest tick)
      var rect = chart.canvas.getBoundingClientRect();
      var x = evt.clientX - rect.left;

      var xScale = chart.scales && (chart.scales["x-axis-0"] || chart.scales["x"]);
      if (!xScale) return null;

      var ticks = xScale.ticks || [];
      if (!ticks.length) return null;

      var minDist = Infinity;
      var nearest = null;

      for (var i = 0; i < ticks.length; i++) {
        var px = xScale.getPixelForTick(i);
        var dist = Math.abs(px - x);
        if (dist < minDist) {
          minDist = dist;
          nearest = i;
        }
      }

      if (minDist > 45) return null;
      return nearest;
    },

    handleSdvClick(evt) {
      if (!this.sdvChart) return;

      // drilldown only from study view
      if (this.sdvLevel !== "study") return;

      var index = this.getIndexFromClick_sdv(evt, this.sdvChart);
      if (index == null) return;

      var picked = this.sdvStudyMap && this.sdvStudyMap[index];
      if (picked && picked.studyId) {
        this.loadSdvSitesByStudy(picked.studyId, picked.studyRef);
      }
    },
    resetSdvChart() {
      this.loadSdvStudies();
    },

    /* 6. SAE Timeliness (line) */
    initSAETimeliness() {
      var canvas = document.getElementById("saeTimelinessChart");
      if (!canvas) return;

      if (this.saeChart) this.saeChart.destroy();

      var ctx = canvas.getContext("2d");

      this.saeChart = new Chart(ctx, {
        type: "line",
        data: {
          labels: [],
          datasets: [
            {
              label: "Median Hours",
              data: [],
              borderColor: "#ad1457",
              backgroundColor: "#ad1457",
              borderWidth: 3,
              pointRadius: 4,
              pointHoverRadius: 6,
              tension: 0.35,
              fill: false,
            },
          ],
        },
        options: {
          responsive: true,
          maintainAspectRatio: false,

          hover: { mode: "nearest", intersect: false },

          tooltips: {
            mode: "nearest",
            intersect: false,
            callbacks: {
              label: (tooltipItem) => {
                var i = tooltipItem.index;

                var medArr = this.saeMetaMedian || [];
                var cntArr = this.saeMetaCount || [];

                var med = (medArr[i] !== undefined && medArr[i] !== null) ? medArr[i] : 0;
                var cnt = (cntArr[i] !== undefined && cntArr[i] !== null) ? cntArr[i] : 0;

                return [
                  "Median Hours: " + med,
                  "Serious AE Count: " + cnt,
                ];
              },
            },
          },

          // click anywhere on chart area
          onClick: (evt) => this.handleSaeClick(evt),

          scales: {
            yAxes: [{
              ticks: { beginAtZero: true },
              scaleLabel: { display: true, labelString: "Median Hours" },
            }],
            xAxes: [{
              ticks: { autoSkip: false },
              scaleLabel: {
                display: true,
                labelString: (this.saeLevel === "study" ? "Studies" : "Sites"),
              },
            }],
          },

          legend: { display: false },
        },
      });

      // initial load
      this.loadSaeStudies();
    },

    async loadSaeStudies() {
      try {
        var idtoken = store.getters.getIdToken;

        var res = await axios.get(
          this.baseapi + "/forms/rbqm/getseriousaereportingtimeliness",
          {
            headers: {
              Authorization: "Bearer " + idtoken,
              "Content-Type": "application/json",
            },
          }
        );

        var rows = Array.isArray(res.data) ? res.data : [];

        this.saeLevel = "study";
        this.selectedSaeStudyId = null;
        this.selectedSaeStudyRef = "";

        this.saeStudyMap = rows.map((r) => ({ studyId: r.studyId, studyRef: r.studyRef }));

        var labels = rows.map((r) => r.studyRef || "-");
        var med = rows.map((r) => Number(r.medianHours) || 0);
        var cnt = rows.map((r) => Number(r.seriousAECount) || 0);

        this.saeMetaMedian = med;
        this.saeMetaCount = cnt;

        this.applySaeChartData(labels, med);
      } catch (err) {
        console.error("SAE studies API error", err);
      }
    },

    async loadSaeSitesByStudy(studyId, studyRef) {
      try {
        var idtoken = store.getters.getIdToken;

        var res = await axios.get(
          this.baseapi + "/forms/rbqm/getseriousaereportingtimeliness?studyId=" + encodeURIComponent(studyId),
          {
            headers: {
              Authorization: "Bearer " + idtoken,
              "Content-Type": "application/json",
            },
          }
        );

        var rows = Array.isArray(res.data) ? res.data : [];

        this.saeLevel = "site";
        this.selectedSaeStudyId = studyId;
        this.selectedSaeStudyRef = studyRef || "";

        var labels = rows.map((r) => r.siteCode || "-");
        var med = rows.map((r) => Number(r.medianHours) || 0);
        var cnt = rows.map((r) => Number(r.seriousAECount) || 0);

        this.saeMetaMedian = med;
        this.saeMetaCount = cnt;

        this.applySaeChartData(labels, med);
      } catch (err) {
        console.error("SAE sites drilldown API error", err);
      }
    },

    applySaeChartData(labels, values) {
      if (!this.saeChart) return;

      this.saeChart.data.labels = labels;
      this.saeChart.data.datasets[0].data = values;

      // horizontal scroll sizing
      var perCategoryPx = 90;
      var minWidth = 600;
      var targetWidth = Math.max(minWidth, labels.length * perCategoryPx);

      var canvas = document.getElementById("saeTimelinessChart");
      if (canvas) {
        var inner = canvas.closest(".chart-inner");
        if (inner) inner.style.width = targetWidth + "px";
      }

      this.saeChart.update();
    },

    getIndexFromClick_sae(evt, chart) {
      if (!chart) return null;

      // 1) If user clicked a point, use nearest element
      var pts = chart.getElementsAtEventForMode
        ? chart.getElementsAtEventForMode(evt, "nearest", { intersect: false }, true)
        : [];

      if (pts && pts.length) return pts[0]._index;

      // 2) Otherwise, compute nearest tick from click x
      var rect = chart.canvas.getBoundingClientRect();
      var x = evt.clientX - rect.left;

      var xScale = chart.scales && (chart.scales["x-axis-0"] || chart.scales["x"]);
      if (!xScale) return null;

      var ticks = xScale.ticks || [];
      if (!ticks.length) return null;

      var minDist = Infinity;
      var nearest = null;

      for (var i = 0; i < ticks.length; i++) {
        var px = xScale.getPixelForTick(i);
        var dist = Math.abs(px - x);
        if (dist < minDist) {
          minDist = dist;
          nearest = i;
        }
      }

      // if click is too far away from any tick, ignore
      if (minDist > 45) return null;

      return nearest;
    },

    handleSaeClick(evt) {
      if (!this.saeChart) return;

      // drilldown only from study view
      if (this.saeLevel !== "study") return;

      var index = this.getIndexFromClick_sae(evt, this.saeChart);
      if (index === null || index === undefined) return;

      var picked = this.saeStudyMap && this.saeStudyMap[index];
      if (picked && picked.studyId) {
        this.loadSaeSitesByStudy(picked.studyId, picked.studyRef);
      }
    },

    resetSaeChart() {
      this.loadSaeStudies();
    },

    async getcrfcompletecount() {
      try {
        const idtoken = store.getters.getIdToken;

        const res = await axios.get(
          `${this.baseapi}/forms/rbqm/getcrfcompletecount?studyId=${this.ecrfcompletstudy}`,
          {
            headers: {
              Authorization: "Bearer " + idtoken,
              "Content-Type": "application/json",
            },
          }
        );

        const { dueCount, ontimeCount } = res.data;

        if (!dueCount || !this.ecrfChart) return;

        const onTimePercent = ((ontimeCount / dueCount) * 100).toFixed(2);
        const latePercent = (100 - onTimePercent).toFixed(2);

        this.ecrfChart.data.datasets[0].data = [
          Number(onTimePercent),
          Number(latePercent),
        ];

        this.ecrfChart.update();
      } catch (err) {
        console.error("eCRF completeness API error", err);
      }
    },
    async getscreenfailurerate() {
      try {
        const idtoken = store.getters.getIdToken;
        const studyId = store.getters.getStudyIs;

        const res = await axios.get(
          `${this.baseapi}/forms/rbqm/getscreenfailurerate?studyId=${studyId}`,
          {
            headers: {
              Authorization: "Bearer " + idtoken,
              "Content-Type": "application/json",
            },
          }
        );

        const rows = Array.isArray(res.data) ? res.data : [];
        console.log("getscreenfailurerate", rows);

        if (!this.screenFailChart) return;

        // Labels = siteCode (or studyCode if that’s what you have)
        const labels = rows.map((r) => r.siteCode || "-");

        // Datasets
        const screened = rows.map((r) => Number(r.screenedCount) || 0);
        const failures = rows.map((r) => Number(r.screenFailureCount) || 0);
        const pct = rows.map((r) => Number(r.percentage) || 0);

        this.screenFailChart.data.labels = labels;
        this.screenFailChart.data.datasets[0].data = screened;
        this.screenFailChart.data.datasets[1].data = failures;
        this.screenFailChart.data.datasets[2].data = pct;

        const perCategoryPx = 80;
        const minWidth = 600;
        const targetWidth = Math.max(minWidth, labels.length * perCategoryPx);

        const canvas = document.getElementById("screenFailChart");
        const inner = canvas?.closest(".chart-inner");
        if (inner) inner.style.width = `${targetWidth}px`;

        this.screenFailChart.update();
      } catch (err) {
        console.error("getscreenfailurerate API error", err);
      }
    },

  },

};
